<template>
  <v-card>
    <v-tabs
      v-model="tab"
      vertical
      slider-color="branche"
      class="tabs ml-1"
    >
      <v-tab
        v-for="item in tabs"
        :key="item.id"
        active-class="branche--text"
        @click="goToTarget(item)"
      >
        <v-card-text class="text-left text-body-perso py-0">
          {{ item.label }}
        </v-card-text>
      </v-tab>
    </v-tabs>
  </v-card>
</template>

<script>
export default {
  name: 'BaseNavTabVertical',
  props: {
    /**
     * [{label:'nom onglet', id:'id' }]
     */
    tabs: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      tab: 0
    }
  },
  computed: {
    elements () {
      let result = []
      this.tabs.forEach(t => {
        let domElement = document.getElementById(t.id)
        let element = t
        element['positionTop'] = domElement.offsetTop
        element['positionBottom'] = domElement.offsetTop - domElement.offsetHeight
        result.push(element)
      })
      return result
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    goToTarget (tab) {
      let element = document.getElementById(tab.id)
      element.scrollIntoView({ behavior: 'instant', block: 'center', inline: 'start' })
      this.tab = this.tabs.findIndex(t => t.id === element.id)
    },
    handleScroll () {
      this.elements.forEach(elt => {
        if (elt.positionBottom < window.scrollY && window.scrollY < elt.positionTop) {
          this.tab = this.tabs.findIndex(t => t.id === elt.id)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.tabs {
  position: fixed;
}
.text-body-perso {
  font-size: 13px;
}
.v-tabs--vertical > .v-tabs-bar .v-tab {
  height: 35px;
}
</style>